import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { StaticFileService } from './static-file.service';
import { GoogleAnalyticsService } from './google-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'artist-site';

  constructor(public staticFileService: StaticFileService, 
              private router: Router,
              private gs: GoogleAnalyticsService) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        this.gs.pageView(event.urlAfterRedirects);
      }
    });
  }
}
